/* T8 collection grid: filter drawer (focus trap, Esc, scroll lock), sort dropdown, and AJAX re-render of the section
   via ?section_id= on filter/sort/pagination changes (falls back to a full navigation if the fetch fails). */
(function () {
  'use strict';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function init(root) {
    (root || document).querySelectorAll('[data-t8-cgrid]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var sectionId = el.dataset.sectionId;
      var baseUrl = el.dataset.url || location.pathname;
      var results = el.querySelector('[data-t8-cgrid-results]');
      var drawer = el.querySelector('[data-t8-cgrid-drawer]');
      var form = el.querySelector('[data-t8-cgrid-form]');
      var openBtn = el.querySelector('[data-t8-cgrid-open]');
      var lastFocus = null, pending = null;
      var gen = 0, shownUrl = null;   // gen: bumped on every filter / sort load, so a late "load more" for the old list is dropped

      /* ---------- drawer ---------- */
      function openDrawer() {
        if (!drawer) return;
        lastFocus = document.activeElement;
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.body.classList.add('t8-cgrid-lock');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        var first = drawer.querySelector('[data-t8-cgrid-close]');
        if (first) first.focus();
        document.addEventListener('keydown', onKey);
      }
      function closeDrawer() {
        if (!drawer || drawer.hidden) return;
        drawer.classList.remove('is-open');
        document.body.classList.remove('t8-cgrid-lock');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKey);
        setTimeout(function () { drawer.hidden = true; }, 350);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function onKey(e) {
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      if (openBtn) openBtn.addEventListener('click', openDrawer);
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-t8-cgrid-close]')) closeDrawer();
      });

      /* ---------- sort ---------- */
      var sort = el.querySelector('[data-t8-cgrid-sort]');
      if (sort) {
        var sortBtn = sort.querySelector('button'), menu = sort.querySelector('.t8-cgrid__sortmenu');
        function toggleMenu(open) {
          menu.hidden = !open; sortBtn.setAttribute('aria-expanded', String(open));
          if (open) { var sel = menu.querySelector('[aria-selected="true"] button') || menu.querySelector('button'); if (sel) sel.focus(); }
        }
        sortBtn.addEventListener('click', function () { toggleMenu(menu.hidden); });
        sort.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !menu.hidden) { toggleMenu(false); sortBtn.focus(); }
          if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !menu.hidden) {
            e.preventDefault();
            var opts = Array.prototype.slice.call(menu.querySelectorAll('button'));
            var i = opts.indexOf(document.activeElement);
            var n = e.key === 'ArrowDown' ? (i + 1) % opts.length : (i - 1 + opts.length) % opts.length;
            opts[n].focus();
          }
        });
        document.addEventListener('click', function (e) { if (!sort.contains(e.target) && !menu.hidden) toggleMenu(false); });
        menu.addEventListener('click', function (e) {
          var opt = e.target.closest('[data-t8-cgrid-sortopt]'); if (!opt) return;
          toggleMenu(false);
          var url = new URL(location.href);
          url.searchParams.set('sort_by', opt.dataset.t8CgridSortopt);
          url.searchParams.delete('page');
          if (form) form.querySelector('input[name="sort_by"]').value = opt.dataset.t8CgridSortopt;
          load(url.toString(), true);
        });
      }

      /* ---------- filters form ---------- */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          clearTimeout(pending);
          var url = formUrl();
          closeDrawer();
          if (url !== shownUrl) load(url, true);   // a pick already re-rendered the grid behind the drawer: Show results only closes it
        });
        form.addEventListener('change', function (e) {
          if (e.target.type === 'number') return; /* price applies on submit */
          /* tag refiners: one pick per group (Colour / Subject / Style) */
          var g = e.target.dataset && e.target.dataset.t8Taggroup;
          if (g && e.target.checked) form.querySelectorAll('[data-t8-taggroup="' + g + '"]').forEach(function (x) { if (x !== e.target) x.checked = false; });
          clearTimeout(pending);
          pending = setTimeout(function () { load(formUrl(), true, true); }, 300);
        });
      }
      function formUrl() {
        var params = new URLSearchParams();
        Array.prototype.forEach.call(form.elements, function (f) {
          if (!f.name) return;
          if ((f.type === 'checkbox' || f.type === 'radio') && !f.checked) return;
          if (f.value === '') return;
          params.append(f.name, f.value);
        });
        /* tag refiners: the collection's tag path (/collections/x/animals+brown), or tag:"…" in a search query */
        var picked = Array.prototype.filter.call(form.querySelectorAll('[data-t8-tag]'), function (x) { return x.checked; });
        if (form.hasAttribute('data-t8-search')) {
          var terms = (form.querySelector('[data-t8-terms]') || {}).value || '';
          var q = [terms].concat(picked.map(function (x) { return 'tag:"' + x.dataset.t8Tag + '"'; })).join(' ').trim();
          params.set('q', q);
          return baseUrl + '?' + params.toString();
        }
        var path = baseUrl + (picked.length ? '/' + picked.map(function (x) { return x.value; }).join('+') : '');
        return path + '?' + params.toString();
      }
      /* price quick ranges: fill both fields and apply */
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-t8-price]'); if (!b || !form) return;
        var r = b.dataset.t8Price.split('-'), box = b.closest('.t8-cgrid__facetbody');
        var ins = box ? box.querySelectorAll('input[type="number"]') : [];
        if (ins.length < 2) return;
        var on = b.classList.contains('is-active');
        ins[0].value = on ? '' : r[0]; ins[1].value = on ? '' : r[1];
        load(formUrl(), true, true);
      });
      /* active tag chips in the toolbar: untick that tag and reload */
      el.addEventListener('click', function (e) {
        var c = e.target.closest('[data-t8-untag]'); if (!c || !form) return;
        form.querySelectorAll('[data-t8-tag]').forEach(function (x) { if (x.value === c.dataset.t8Untag) x.checked = false; });
        load(formUrl(), true);
      });
      function markPresets() {
        el.querySelectorAll('.t8-cgrid__presets').forEach(function (g) {
          var ins = g.closest('.t8-cgrid__facetbody').querySelectorAll('input[type="number"]');
          var cur = (ins[0] ? ins[0].value : '') + '-' + (ins[1] ? ins[1].value : '');
          g.querySelectorAll('[data-t8-price]').forEach(function (b) { var r = b.dataset.t8Price; var on = cur === r || (r.slice(0, 2) === '0-' && cur === '-' + r.slice(2)); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
        });
      }
      markPresets();
      document.addEventListener('t8:collection:updated', function (e) { if (e.detail && e.detail.section === el) markPresets(); });

      /* links: pagination, chips, clear */
      el.addEventListener('click', function (e) {
        var a = e.target.closest('[data-t8-cgrid-link]'); if (!a || !el.contains(a)) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        var inDrawer = drawer && drawer.contains(a);
        load(a.href, true, inDrawer);
        if (a.closest('.t8-cgrid__pagination')) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      /* ---------- All / Portrait / Landscape (no orientation filter: switch the loaded cards by artwork shape) ---------- */
      var orient = 'all';
      function applyOrient() {
        var grid = el.querySelector('.t8-cgrid__grid'); if (!grid) return;
        var shown = 0;
        grid.querySelectorAll('.t8-pcard').forEach(function (c) {
          var o = c.dataset.orientation || '';
          var hide = orient !== 'all' && o !== orient;
          c.classList.toggle('is-orient-hidden', hide);
          if (!hide) shown++;
        });
        var note = grid.querySelector('.t8-cgrid__orientempty');
        if (!shown && orient !== 'all') {
          if (!note) { note = document.createElement('p'); note.className = 't8-cgrid__orientempty'; grid.appendChild(note); }
          note.textContent = 'No ' + orient + ' pieces on this page yet.';
        } else if (note) note.remove();
      }
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-t8-orient]'); if (!b) return;
        orient = b.dataset.t8Orient;
        el.querySelectorAll('[data-t8-orient]').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
        applyOrient();
      });
      document.addEventListener('t8:collection:updated', function (e) {
        if (!e.detail || e.detail.section !== el) return;
        el.querySelectorAll('[data-t8-orient]').forEach(function (x) { var on = x.dataset.t8Orient === orient; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
        applyOrient();
      });

      /* ---------- fetch + swap ---------- */
      function load(url, push, keepDrawer) {
        var my = ++gen;
        var u = new URL(url, location.origin);
        if (el.dataset.view && !u.searchParams.has('view')) u.searchParams.set('view', el.dataset.view);   /* stay on this template (e.g. a business space view) */
        u.searchParams.set('section_id', sectionId);
        if (results) results.setAttribute('aria-busy', 'true');
        fetch(u.toString(), { headers: { Accept: 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            if (my !== gen) return;   // a newer pick is on its way
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-t8-cgrid]');
            if (!fresh) throw new Error('no section');
            shownUrl = url;
            swap('[data-t8-cgrid-results]', fresh);
            swap('.t8-cgrid__left', fresh);
            swap('[data-t8-cgrid-sortlabel]', fresh);
            var freshMenu = fresh.querySelector('.t8-cgrid__sortmenu'), menuEl = el.querySelector('.t8-cgrid__sortmenu');
            if (freshMenu && menuEl) menuEl.innerHTML = freshMenu.innerHTML;
            var freshFacets = fresh.querySelector('.t8-cgrid__facets'), facets = el.querySelector('.t8-cgrid__facets');
            if (freshFacets && facets) facets.innerHTML = freshFacets.innerHTML;
            var freshTotal = fresh.querySelector('[data-t8-cgrid-total]'), total = el.querySelector('[data-t8-cgrid-total]');
            if (freshTotal && total) total.textContent = freshTotal.textContent;
            openBtn = el.querySelector('[data-t8-cgrid-open]');
            if (openBtn) { openBtn.addEventListener('click', openDrawer); openBtn.setAttribute('aria-expanded', keepDrawer && drawer && !drawer.hidden ? 'true' : 'false'); }
            var clean = new URL(url, location.origin); clean.searchParams.delete('section_id');
            if (el.dataset.view && !clean.searchParams.has('view')) clean.searchParams.set('view', el.dataset.view);
            if (push) history.pushState({ t8cgrid: true }, '', clean.toString());
            if (results) results.setAttribute('aria-busy', 'false');
            document.dispatchEvent(new CustomEvent('t8:collection:updated', { detail: { section: el } }));
          })
          .catch(function () {
            if (my !== gen) return;
            var full = new URL(url, location.origin);   // full page load of the same view, filters kept
            if (el.dataset.view && !full.searchParams.has('view')) full.searchParams.set('view', el.dataset.view);
            location.href = full.toString();
          });
      }
      function swap(sel, fresh) {
        var a = el.querySelector(sel), b = fresh.querySelector(sel);
        if (a && b) a.innerHTML = b.innerHTML;
      }
      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.t8cgrid) load(location.href, false);
      });

      /* ---------- load as you scroll (data-t8-cgrid-infinite): near the end, fetch the next page through the section
         and add its cards to the grid; the page links stay in the markup as the no-script fallback ---------- */
      if (el.hasAttribute('data-t8-cgrid-infinite') && 'IntersectionObserver' in window) {
        var busyMore = false;
        var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) more(); }, { rootMargin: '100000px 0px 900px 0px' });   // also when the shopper has flung past the end (the links are above the screen)
        function watch() {
          io.disconnect();
          var nav = el.querySelector('.t8-cgrid__pagination');
          if (nav && nextUrl()) io.observe(nav);
        }
        function nextUrl() {
          var nav = el.querySelector('.t8-cgrid__pagination'); if (!nav) return null;
          var btns = nav.querySelectorAll('.t8-cgrid__pagebtn'), last = btns[btns.length - 1];
          return last && last.tagName === 'A' ? last.getAttribute('href') : null;
        }
        function more() {
          var url = nextUrl(); if (!url || busyMore) return;
          busyMore = true; el.classList.add('is-loading-more');
          var my = gen;
          var u = new URL(url, location.origin);
          if (el.dataset.view && !u.searchParams.has('view')) u.searchParams.set('view', el.dataset.view);
          u.searchParams.set('section_id', sectionId);
          fetch(u.toString(), { headers: { Accept: 'text/html' } })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
            .then(function (html) {
              if (my !== gen) return;   // the filters / sort changed while this page loaded: its cards belong to the old list
              var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-t8-cgrid]');
              var grid = el.querySelector('.t8-cgrid__grid'), add = fresh && fresh.querySelector('.t8-cgrid__grid');
              if (!grid || !add) throw new Error('no grid');
              // a print already on screen is skipped: search results (and best-selling ties) can shift between page requests
              var have = {};
              grid.querySelectorAll('[data-product-id]').forEach(function (c) { have[c.dataset.productId] = 1; });
              Array.prototype.slice.call(add.children).forEach(function (c) {
                var id = c.dataset && c.dataset.productId;
                if (id && have[id]) return;
                if (id) have[id] = 1;
                grid.appendChild(c);
              });
              var nav = el.querySelector('.t8-cgrid__pagination'), freshNav = fresh.querySelector('.t8-cgrid__pagination');
              if (nav && freshNav) nav.innerHTML = freshNav.innerHTML; else if (nav) nav.remove();
              document.dispatchEvent(new CustomEvent('t8:collection:updated', { detail: { section: el } }));   // cards, wishlist and the orientation switch pick up the new cards
            })
            .catch(function () { if (my === gen) location.href = url; })
            .then(function () { busyMore = false; el.classList.remove('is-loading-more'); watch(); });
        }
        document.addEventListener('t8:collection:updated', function (e) { if (e.detail && e.detail.section === el && !busyMore) watch(); });   // a filter / sort change starts again from page 1
        watch();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
